import { Button, Col, Row, Typography } from 'antd';
import {
  FormTextArea,
  LoadingState,
  useLoading,
} from '@monorepo/react-components';
import { MAX_CHARS_DEFAULT, Scene } from '@monorepo/types';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useVideoContext } from '../../../../../../../hooks/use-video';
import { useStore } from '../../../../../../../helpers/use-store';
import { useNotification } from '../../../../../../../hooks/use-notification';
import { useTranslation } from 'react-i18next';

export type EditSceneTextForm = Pick<Scene, 'text'>;

const EditSceneText = () => {
  const { t } = useTranslation();
  const { loadingState, updateLoadingState } = useLoading();
  const form = useForm<EditSceneTextForm>();
  const {
    updateScene,
    scenes,
    selectedScene: scene,
    getSceneStartFrame,
  } = useVideoContext();
  const notificationApi = useNotification();
  const {
    dataStore: { userStore },
  } = useStore();

  const resetForm = () => {
    if (scene) {
      form.reset({
        text: scene.text,
      });
    }
  };

  useEffect(() => {
    resetForm();
  }, [scene]);

  const save = async () => {
    if (!scene) {
      return;
    }

    const values = form.getValues();

    try {
      updateLoadingState(LoadingState.Loading);

      // const frame = getSceneStartFrame(scene._id);

      await updateScene({
        sceneId: scene._id,
        videoId: scene.videoId,
        updateDto: {
          text: values.text,
        },
        frameToSeek: -1,
        shouldUpdateState: true,
      });

      userStore.getLatestUser();

      notificationApi.success({
        placement: 'top',
        message: t('common.success'),
        description: t('videoEditor.editText.updateSuccess'),
      });
    } catch (e) {
      notificationApi.error({
        placement: 'top',
        icon: '',
        message: t('common.error'),
        description: t('videoEditor.editText.updateError'),
      });

      console.error(`failed`, e);
    } finally {
      updateLoadingState(LoadingState.Loaded);

      form.reset({ text: values.text });
    }
  };

  const globalMaxLength =
    userStore.currentUser.applicationConfig?.maxCharsForScript ||
    MAX_CHARS_DEFAULT;
  const scenesTotal = scenes.map((scene) => scene.text).join(' ').length;
  const sceneMaxLeft =
    globalMaxLength - (scenesTotal - (form.getValues('text') || '').length);

  return (
    <Row gutter={[25, 25]} style={{ marginBottom: '10px' }}>
      <Col span={24}>
        <Typography.Title style={{ margin: 0, marginBottom: '5px' }} level={5}>
          {t('videoEditor.editText.voiceoverTextLabel')}
        </Typography.Title>
        <FormTextArea
          textareaProps={{
            maxLength: sceneMaxLeft,
            showCount: true,
            rows: 3,
          }}
          form={form}
          controllerProps={{
            name: 'text',
          }}
        />

        <Button
          type={'primary'}
          style={{ width: '100%', marginTop: '25px' }}
          {...{
            loading: loadingState === LoadingState.Loading,
            // disabled: !form.formState.isDirty,
            onClick: save,
          }}
        >
          {t('videoEditor.editText.update')}
        </Button>
        <Typography.Text style={{ fontSize: '12px' }} type={'secondary'}>
          {t('videoEditor.editText.updateNote')}
        </Typography.Text>
      </Col>
    </Row>
  );
};

export default EditSceneText;
